import AudioArticleSignUp from "./AudioArticleSignUp";

const { register } = require("@lpm/pug-components/dist/register");

register("AudioArticleSignUp/AudioArticleSignUp", AudioArticleSignUp);
